<!--
  提现
  lovi 2020-1-11
-->
<template>
  <div class="w100">
    <van-nav-bar
      class="gradient"
      :title="$t('wallet.withdraw')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    >
      <span slot="right" @click="_linkFun('/record?flag=2')">
        {{ $t("common.withdrawalRecord") }}
      </span>
    </van-nav-bar>

    <div class="scroll-wrapper">
      <div class="bg"></div>
      <scroll ref="scroll">
        <div class="column">
          <van-cell-group v-if="bankList.length">
            <van-cell
              class="bank-list"
              :title="bankList[curIndex].bank_name"
              :label="
                $t('wallet.lastFourDigits') +
                  lastFour(bankList[curIndex].card_number)
              "
              @click="chooseBankFlag = true"
              is-link
            />
          </van-cell-group>
          <div class="title">{{ $t("withdraw.withdrawAmount") }}</div>
          <div class="money-wrap">
            <van-field
              class="van-field-input"
              v-model="money"
              type="number"
              :formatter="_formatter"
              :placeholder="$t('common.enterAmount')"
              clearable
            >
              <span slot="right-icon">P</span>
            </van-field>
            <div class="tips">
              <span
                class="text-orange"
                v-if="
                  bankList.length &&
                    (bankList[curIndex].country == 1 ||
                      bankList[curIndex].country == 3)
                "
                >≈{{ bankList[curIndex].country == 1 ? "￥" : ""
                }}{{ withdrawMoney
                }}{{ bankList[curIndex].country == 3 ? "VND" : "" }}
              </span>
              <span v-else></span>
              <div class="info">
                <span>
                  {{ $t("common.balance")
                  }}{{ userInfo.money_usable ? userInfo.money_usable : "--" }}P
                </span>
                <a href="javascript:void(0)" @click="allMoney">
                  {{ $t("withdraw.withdrawAll") }}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="button-wrap">
          <van-button
            round
            type="primary"
            block
            :loading="btnLoading"
            @click="submit"
          >
            {{ $t("common.confirm") }}
          </van-button>
          <p class="tips">
            {{ $t("withdraw.singleWithdrawalLimited") }}
            {{
              (curData.amount_min ? curData.amount_min : "--") +
                "P-" +
                (curData.amount_max ? curData.amount_max : "--") +
                "P"
            }}
            <br />
            {{ $t("withdraw.monthWithdrawalLimited") }}
            {{ configData.tx_raming ? configData.tx_raming : "--" }}P
          </p>
        </div>
      </scroll>
    </div>

    <!-- 选择银行卡 -->
    <transition name="slide">
      <choose-bank
        v-if="chooseBankFlag"
        :chooseBankFlag.sync="chooseBankFlag"
        :bindCardFlag.sync="bindCardFlag"
        :bankList="bankList"
        :curIndex.sync="curIndex"
      />
    </transition>

    <!-- 绑定银行卡 -->
    <transition name="slide">
      <bind-card
        v-if="bindCardFlag"
        :bindCardFlag.sync="bindCardFlag"
        :parentPage="'withdraw'"
        @getWithdrawalToBank="getWithdrawalToBank"
      />
    </transition>

    <enter-payPsd
      :payPsdFlag.sync="payPsdFlag"
      :data="payPsdData"
      @getPayPsd="cashWithdrawal"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ChooseBank from "./chooseBank";
import BindCard from "../../bankCard/bindCard";
import EnterPayPsd from "@/components/enterPayPsd";
export default {
  name: "withdrawBank",
  meta: {
    keepAlive: true
  },
  components: {
    ChooseBank,
    BindCard,
    EnterPayPsd
  },
  data() {
    return {
      configData: {}, //配置数据
      curData: {},
      bankList: [],
      curIndex: 0,

      money: "",
      btnLoading: false, // 按钮loading
      withdrawMoney: "--", // 提现折算金额

      chooseBankFlag: false, // 选择银行卡
      bindCardFlag: false, // 绑定银行卡

      payPsdFlag: false,
      payPsdData: {
        title: this.$t("withdraw.withdrawAmount"),
        money: "",
        tips: ""
      }
    };
  },
  created() {
    let vm = this;
    vm.getWithdrawalToBank();
  },
  mounted() {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    lastFour(data) {
      // 保留银行卡后4位
      let newData = data.substring(data.length - 4);
      return newData;
    },
    allMoney() {
      // 全部金额
      this.money = Number(this.userInfo.money_usable);
    },
    submit() {
      let vm = this;
      if (vm.money == "" || vm.money <= 0) {
        vm.$toast(vm.$t("common.enterCorrectAmount"));
        return false;
      }
      // 账户余额
      let money = Number(vm.userInfo.money_usable);
      if (Number(vm.money) > money) {
        vm.$toast(vm.$t("common.insufficientAccountBalance"));
        return false;
      }
      if (
        vm.curData.amount_min &&
        Number(vm.money) < Number(vm.curData.amount_min)
      ) {
        vm.$toast(vm.$t("common.amountCannotMin") + vm.curData.amount_min);
        return false;
      }
      if (
        vm.curData.amount_max &&
        Number(vm.money) > Number(vm.curData.amount_max)
      ) {
        vm.$toast(vm.$t("common.amountCannotMax") + vm.curData.amount_max);
        return false;
      }
      if (Number(vm.money) > Number(vm.configData.tx_raming)) {
        vm.$toast(vm.$t("withdraw.withdrawalAmountGreaterThanMonth"));
        return false;
      }

      // 手续费计算
      let feeTips = "";
      let fee = vm.curData.percentage;
      if (vm.curData.type == 0) {
        feeTips =
          vm.$t("common.serviceRate") +
          Number(fee) * 100 +
          "%(" +
          vm.$t("common.minServiceCharge") +
          vm.curData.low_fee +
          "P)";
      } else {
        // 具体金额
        let money1, money2;
        money1 = vm.curData.check_money;
        money2 = vm.curData.check_service_money;
        fee = Number(Math.ceil(vm.money / money1) * money2).toFixed(2);
        feeTips = vm.$t("common.serviceCharge") + fee + "P";
        if (money <= Number(vm.curData.low_fee) || money <= fee) {
          vm.$toast(vm.$t("common.insufficientAccountBalance"));
          return;
        }
      }
      vm.payPsdData.money = vm.money.toFixed(2);
      vm.payPsdData.tips = feeTips;
      vm.payPsdFlag = true;
    },
    cashWithdrawal(data) {
      // 提现
      let vm = this;
      let params = {};
      params.operate = 8;
      params.money = vm.money;
      params.country = vm.bankList[vm.curIndex].country;
      params.bank_card_id = vm.bankList[vm.curIndex].id;
      params.pay_password = data;
      vm.$post("/app/pay/cashWithdrawal", params, { loading: true }).then(
        res => {
          console.log("cashWithdrawal", res);
          vm.$store.dispatch("GET_USER_INFO");
          vm.getWithdrawalToBank();
          vm.$router.push({
            // 提现详情
            path: "/detail",
            name: "detail",
            query: { flag: 2, order_id: res.list[0].id }
          });
        }
      );
    },
    getWithdrawalToBank() {
      // 获取提现到银行卡页面信息
      let vm = this;
      vm.$post("/app/pay/WithdrawalToBank", {}, { loading: true }).then(res => {
        console.log("WithdrawalToBank", res);
        vm.configData = res.withdraw_config;
        vm.bankList = res.list;
        let country = vm.bankList[vm.curIndex].country;
        vm.curData =
          country == 1
            ? vm.configData.rmb
            : country == 2
            ? vm.configData.php
            : vm.configData.vnd;
        console.log("curData", vm.curData);
      });
    }
  },
  watch: {
    money: {
      handler(newVal) {
        this.withdrawMoney = this._PHPtoRMB(newVal, this.curData.rate);
      },
      deep: true
    },
    curIndex: {
      handler(newVal) {
        let country = this.bankList[newVal].country;
        this.curData =
          country == 1
            ? this.configData.rmb
            : country == 2
            ? this.configData.php
            : this.configData.vnd;
        this.withdrawMoney = this._PHPtoRMB(this.money, this.curData.rate);
      },
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
.scroll-wrapper {
  background: #f4f4f4;
  .bg {
    height: 50px;
    background: linear-gradient(90deg, #2043ac, #130f73);
  }
}

.bank-list {
  display: flex;
  align-items: center;
  padding: 12px 10px;
  /deep/.van-cell__title {
    line-height: 1;
    span {
      font-size: 18px;
    }
    .van-cell__label {
      margin-top: 6px;
      font-size: 12px;
      line-height: 1;
    }
  }
}

.money-wrap {
  padding: 0px 10px;
  .tips {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    font-size: 12px;
    .info {
      span {
        margin-right: 10px;
      }
      a {
        color: #2042ab;
        text-decoration: underline;
      }
    }
  }
}
</style>
